export default {"src":"/_next/static/media/bcorps-logo.febb8b4a.svg","height":104,"width":72,"blurWidth":0,"blurHeight":0};